/*                                                        */
/*                                     */
import { on } from "svelte/events";
import type { Action } from "svelte/action";
import type { MediaQuery } from "svelte/reactivity";
import { unsetAll } from "@otto-ec/global-resources/event";
import type { useContentScroll } from "./scrollOverflow.svelte";
import { sheetClose } from "../apis/methods.js";
import { SHEET_ACTION_DRAG_DOWN } from "../event/event.action.defs";
import { lockGestureDirection } from "./utils";

const CLOSING_DISTANCE = 100;

/**
 *
 *
 *
 *
 *
 *
 */
export function computeDragStyle(isDragging: boolean, dragDistance: number): string {
  if (!isDragging) return "";

  const dragOffsetY = dragDistance > 0 ? `${dragDistance}px` : "0";
  return `transition: none; transform:translateY(${dragOffsetY})`;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
/*                                                                        */
export const useDragClose = (
  contentScroll: ReturnType<typeof useContentScroll>,
  large: MediaQuery,
  isCloseInteractionsDisabled: () => boolean,
) => {
  /*                                                                    */
  let touchStartY = 0;

  /*                                                             */
  let touchStartX = 0;

  let gestureDirection: "none" | "horizontal" | "vertical" = "none";

  /**
 *
 *
 *
 */
  const onTouchEnd = (): void => {
    /*                             */
    if (large.current) return;

    /*                                                                      */
    /*                                       */
    if (state.isDragging && state.dragDistance > CLOSING_DISTANCE && !isCloseInteractionsDisabled())
      sheetClose({ action: SHEET_ACTION_DRAG_DOWN });

    state.dragDistance = 0;
    state.isDragging = false;
    touchStartY = 0;
    touchStartX = 0;
    gestureDirection = "none";
  };

  const state = $state({
    /**
 *
 *
 */
    isDragging: false,

    /**
 *
 *
 */
    dragDistance: 0,

    /**
 *
 */
    sheetDragStyle: computeDragStyle(false, 0),

    headerEvents: ((node) =>
      unsetAll(
        on(
          node,
          "touchstart",
          (event) => {
            state.isDragging = true;
            touchStartY = event.touches[0].clientY;
          },
          {
            passive: true,
          },
        ),

        on(
          node,
          "touchmove",
          (event) => {
            if (large.current) return;
            if (!state.isDragging) return;

            state.dragDistance = event.touches[0].clientY - touchStartY;

            /*                                                     */
            if (event.cancelable) event.preventDefault();
          },

          /*                                                                     */
          { passive: false },
        ),

        on(node, "touchend", onTouchEnd),
      )) as Action,

    contentEvents: ((node) =>
      unsetAll(
        on(
          node,
          "touchstart",
          (event) => {
            /*                             */
            if (large.current) return;

            /*                                                                   */
            if (!contentScroll.isScrolling) {
              touchStartY = event.touches[0].clientY;
              touchStartX = event.touches[0].clientX;
            }
            /*                               */
            state.dragDistance = 0;
            state.isDragging = false;
            gestureDirection = "none";
          },
          {
            passive: true,
          },
        ),

        on(
          node,
          "touchmove",
          (event) => {
            /*                             */
            if (large.current) return;
            event.stopPropagation();

            /*                                                                                      */
            if (touchStartY === 0) return;

            const currentY = event.touches[0].clientY;
            const currentX = event.touches[0].clientX;
            const deltaY = currentY - touchStartY; /*                          */
            const deltaX = currentX - touchStartX; /*                            */

            if (deltaY <= 0) {
              state.isDragging = false;
              state.dragDistance = 0;
              return;
            }

            gestureDirection = lockGestureDirection(
              gestureDirection,
              deltaY,
              deltaX,
              contentScroll.isScrolling,
            );

            if (gestureDirection === "horizontal") {
              /*                                                                    */
              return;
            }

            if (gestureDirection === "vertical") {
              /*                                                                 */
              state.isDragging = true;
              state.dragDistance = deltaY;

              /*                                               */
              if (event.cancelable) event.preventDefault();
            }
          },
          /*                                                                     */
          { passive: false },
        ),
        on(node, "touchend", onTouchEnd),
      )) as Action,
  });

  /*                                                                           */
  $effect(() => {
    state.sheetDragStyle = computeDragStyle(state.isDragging, state.dragDistance);
  });

  return state;
};
